<ion-app>
  <ion-split-pane when="md" content-id="main-content">
    <ion-menu [swipeGesture]="false" content-id="main-content">
      <ion-header class="toolbar-roxa">
        <ion-toolbar>
          <img class="monitorar-logo ion-float-left" src="assets/imgs/logo-monitorar.png" alt="">
        </ion-toolbar>
      </ion-header>

      <ion-content>
        <ion-list lines="none">
          <ion-list-header>
            MENU DE AÇÕES
          </ion-list-header>
          <ion-menu-toggle auto-hide="false" routerLink="/mapa" routerLinkActive="link-ativo">
            <ion-item button>
              <ion-icon name="mapa-pin-outline"></ion-icon>
              <ion-label>
                Mapa
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle auto-hide="false" routerLink="/painel" routerLinkActive="link-ativo">
            <ion-item button>
              <ion-icon name="grid-outline"></ion-icon>
              <ion-label>
               Painel
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle auto-hide="false" routerLink="/notificacoes" routerLinkActive="link-ativo" *ngIf="showNotification">
            <ion-item button>
              <ion-icon name="sino"></ion-icon>
              <ion-label>
               Notificações
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle auto-hide="false" routerLink="/definicoes" routerLinkActive="link-ativo">
            <ion-item button>
              <ion-icon name="engrenagem"></ion-icon>
              <ion-label>
                Definições
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle auto-hide="false" routerLink="/documentos" routerLinkActive="link-ativo">
            <ion-item button>
              <ion-icon name="clipboard-outline"></ion-icon>
              <ion-label>
                Documentos
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
      </ion-content>
      <p>Versão - {{versao}}</p>
    </ion-menu>

    <div class="ion-page" id="main-content">
      <ion-router-outlet></ion-router-outlet>
    </div>

  </ion-split-pane>
</ion-app>
